import * as yup from 'yup';

let contactFormSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  message: yup.string().required(),
});

export default contactFormSchema;
